import minusSvg from 'assets/icon/minus.svg';
import React, { MouseEvent } from 'react';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

const TextEditable = styled.div`
  cursor: pointer;
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    margin-left: 6px;
    color: #5cabdd;
  }
`;

const Button = styled.button`
  background: transparent;
  border: none;
  margin-left: 5px;
  display: flex;
`;

type Props = {
  handleClickRemove?: (event: MouseEvent<HTMLElement>) => void;
  index: number | string;
};

const DeleteButton = ({ handleClickRemove, index }: Props) => {
  return (
    <TextEditable>
      <Button id={`section-delete-button-${index}`} onClick={handleClickRemove} type="button">
        <SVG src={minusSvg} />
      </Button>
    </TextEditable>
  );
};

export default DeleteButton;
